import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-perce-wise-score',
  templateUrl: './perce-wise-score.component.html',
  styleUrls: ['./perce-wise-score.component.scss']
})
export class PerceWiseScoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
